const InputNumberTwo = ({
    parameter,
    value,
    setValue,
    disabled,
    step,
    min
}) => {
    const parseValue = (step, value) => {
        if (step === "any") {
            return parseFloat(value);
        }
        if (step === "1") {
            return parseInt(value);
        }
    }
    if (min === null) {
        return <input
            disabled={disabled}
            className=""
            type="number"
            step={step} 
            value={value}
            style={{maxWidth: "6rem"}}
            onChange={(e) => setValue((prev) => ({
                ...prev,
                [parameter]: e.target.value === "" ? "": parseValue(step, e.target.value)
            }))}
        />
    } else {
        return <input
            disabled={disabled}
            className=""
            type="number"
            step={step}
            min={min}
            value={value}
            style={{maxWidth: "6rem"}}
            onChange={(e) => setValue((prev) => ({
                ...prev,
                [parameter]: e.target.value === "" ? "": parseValue(step, e.target.value)
            }))}
        />
    }   
}

export default InputNumberTwo;